var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoEventsIcon = function SvgNoEventsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4583 6.90991C25.1487 6.90991 25.7083 7.46956 25.7083 8.15991C25.7083 8.85027 25.1487 9.40991 24.4583 9.40991V6.90991ZM24.4583 9.40991H20.2283V6.90991H24.4583V9.40991Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1532 37C65.1532 36.3096 65.7129 35.75 66.4032 35.75C67.0936 35.75 67.6532 36.3096 67.6532 37H65.1532ZM12.0109 9.41008H8.93846V6.91008H12.0109V9.41008ZM8.93846 9.41008C5.39723 9.41008 2.52649 12.2808 2.52649 15.822H0.0264893C0.0264893 10.9001 4.01652 6.91008 8.93846 6.91008V9.41008ZM2.52649 15.822L2.52649 58.7387H0.0264893L0.0264893 15.822H2.52649ZM2.52649 58.7387C2.52649 62.2799 5.39723 65.1506 8.93846 65.1506V67.6506C4.01651 67.6506 0.0264893 63.6606 0.0264893 58.7387H2.52649ZM8.93846 65.1506H58.7413V67.6506H8.93846V65.1506ZM58.7413 65.1506C62.2825 65.1506 65.1532 62.2799 65.1532 58.7387H67.6532C67.6532 63.6606 63.6632 67.6506 58.7413 67.6506V65.1506ZM65.1532 58.7387V37H67.6532V58.7387H65.1532Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8819 22.9097C27.5723 22.9097 28.1319 23.4693 28.1319 24.1597C28.1319 24.85 27.5723 25.4097 26.8819 25.4097V22.9097ZM2.47192 22.9097L26.8819 22.9097V25.4097L2.47192 25.4097V22.9097Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1186 14.5142C14.514 14.5142 13.2133 13.2135 13.2133 11.6089L13.2133 4.1823C13.2133 2.5777 14.514 1.27701 16.1186 1.27701C17.7232 1.27701 19.0239 2.5777 19.0239 4.1823V11.6089C19.0239 13.2135 17.7232 14.5142 16.1186 14.5142Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1504 22.3125L42.8379 28L56.8379 14",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7754,
    cy: 21,
    r: 19.75,
    stroke: "#757575",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2754,
    cy: 46.5,
    r: 2.5,
    fill: "#757575"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2754,
    cy: 36.5,
    r: 2.5,
    fill: "#757575"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2754,
    cy: 56.5,
    r: 2.5,
    fill: "#757575"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2754,
    cy: 56.5,
    r: 2.5,
    fill: "#757575"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2754,
    cy: 56.5,
    r: 2.5,
    fill: "#757575"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.2754,
    cy: 56.5,
    r: 2.5,
    fill: "#757575"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2754,
    cy: 46.5,
    r: 2.5,
    fill: "#757575"
  })));
};
export default SvgNoEventsIcon;